import { InvoiceFile } from "src/services/billing/billing.types";
import { IOrgCandidate } from "src/services/candidates/candidates.types";
import { ICompanyProfile } from "src/services/connections/connections.types";
import { Contact } from "src/services/contacts/contacts.types";
import { FileResponse } from "src/services/utils/utils.types";



export enum MeetingStatus {
  SCHEDULED = 'scheduled',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
}

export enum MeetingRecordingStatus {
  UNAVAILABLE = 'unavailable',
  PROCESSING = 'processing',
  AVAILABLE = 'available',
  FAILED = 'failed',
  NOT_REQUIRED = 'not_required'
}

export enum MeetingTranscriptStatus {
  UNAVAILABLE = 'unavailable',
  PROCESSING = 'processing',
  AVAILABLE = 'available',
  FAILED = 'failed',
  NOT_REQUIRED = 'not_required'
}

export enum MeetingType {
  HOSTED = 'hosted',
  EXTERNAL_BOT = 'external_bot'
}

export enum MeetingProvider {
  AWS_CHIME = 'aws_chime',
  RECALL_AI = 'recall_ai',
}

export enum MeetingPlatform {
  NATIVE = 'native',
  GOOGLE_MEET = 'google_meet',
  MICROSOFT_TEAMS = 'microsoft_teams',
  ZOOM = 'zoom'
}

export interface IMeetingParticipant {
  first_name: string;
  last_name?: string;
  email: string;
}

export interface IMeetingTranscript {
  id: string;
  language: string;
  summary: string;
  /** Raw or structured transcript content */
  content: RecordingTranscript;
  recap: string;
}

export interface IMeetingRecording {
  id: string;
  file: FileResponse;
}

export interface IMeeting {
  id: string;
  title: string;
  description: string;
  platform: MeetingPlatform;
  url: string;
  type: MeetingType;
  /** UTC or ISO‑8601 string is common on the wire; hydrate to Date if needed */
  start_at: string | Date;
  timezone: string;
  duration_minutes: number;
  status: MeetingStatus;
  thread: {
    id: string;
  };
  participants: IMeetingParticipant[];
  allow_anonymous?: boolean;
  recording?: IMeetingRecording;
  recording_status: MeetingRecordingStatus;
  recording_fail_reason?: string | null;

  transcript?: IMeetingTranscript;
  transcript_status: MeetingTranscriptStatus;
  transcribe_fail_reason?: string | null;

  related_contact: Contact | null;
  related_company: ICompanyProfile | null;
  related_candidate: IOrgCandidate | null;
}

export interface CreateMeetingParticipantDto {
  first_name: string;
  last_name: string;
  email: string;
}

export interface CreateMeetingProps {
  title: string;
  description: string;
  type: MeetingType;
  url?: string;
  allow_anonymous?: boolean;
  participants: CreateMeetingParticipantDto[]
  start_at: string;
  timezone?: string;
  duration_minutes?: number;

  related_company_id: string | null;
}

export interface UpdateMeetingProps extends Partial<CreateMeetingProps> {
  assigned_to_id?: string;

}

export type Timestamp = {
  relative: number;
  absolute: string;
};

export type Participant = {
  name: string;
  is_host?: boolean;
  metadata?: Record<string, any>;
};

export type Phrase = {
  text: string;
  start_timestamp: Timestamp;
  end_timestamp: Timestamp;
};

export type TranscriptSegment = {
  participant: Participant;
  phrase: Phrase[];
};


export type RecordingTranscript = TranscriptSegment[];

